/**
 * Notification Provider
 *
 * Initializes real-time notification WebSocket connection for authenticated users.
 * Shows toast notifications when new proposals or other notifications arrive.
 */

'use client';

import { useNotifications } from '../hooks/useNotifications';

interface NotificationProviderProps {
  children: React.ReactNode;
}

export function NotificationProvider({ children }: NotificationProviderProps) {
  // Initialize notification socket and show toasts for important events
  useNotifications({
    showToasts: true,
  });

  return <>{children}</>;
}
